import React from 'react';
import './Home.js.css';
import Container from '../components/Container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PageComponent from '../components/PageComponent';

export default class Page404 extends PageComponent {

  static PageInfo = { 
    show: false,
    
    path: "*",
    name: "menu.notfound",
    icon: "question-circle"
  }

  constructor(props) {
    super(props);
    try {
      this.data = props.match.params;
    } catch (e) { }
  }

  renderPage() {
    return <div>
      Error 404:
     <br />
     Page not found!
    </div>;
  }

  render() {
    return (
      global.token != null ?
        <Container context={this.constructor} props={this.data}>
          {this.renderPage()}
        </Container>
        : this.renderPage()
    );
  }
}

